import apiClient from '@/api/client';
import type {
  RecomputeProgress,
  RecomputeTriggerResponse,
} from '@/types/recompute';

export async function fetchRecomputeProgress(): Promise<RecomputeProgress> {
  const response = await apiClient.get<RecomputeProgress>('/api/v1/recompute/progress');
  return response.data;
}

/**
 * Starts the global manual recompute job. Throws on 409 (already running) or
 * 503 (coordination unavailable) — callers handle those via axios error.
 */
export async function triggerRecompute(): Promise<RecomputeTriggerResponse> {
  const response = await apiClient.post<RecomputeTriggerResponse>('/api/v1/recompute');
  return response.data;
}
